import api from './api';

export const proteinService = {
  async getProteins({ page = 1, limit = 100 } = {}) {
    const response = await api.get('/menu-proteins', { params: { page, limit } });
    return response.data;
  },

  async getProtein(id) {
    const response = await api.get(`/menu-proteins/${id}`);
    return response.data.data;
  },

  async createProtein(data) {
    const response = await api.post('/menu-proteins', data);
    return response.data.data;
  },

  async updateProtein(id, data) {
    const response = await api.put(`/menu-proteins/${id}`, data);
    return response.data.data;
  },

  async deleteProtein(id) {
    const response = await api.delete(`/menu-proteins/${id}`);
    return response.data.data;
  }
};
